import React, { useContext } from 'react';
import LocalizationContext from '../../contexts/LocalizationContext';
import '../../../css/Forbidden.css';

var Forbidden = function Forbidden() {
  var localizedStrings = useContext(LocalizationContext);
  return /*#__PURE__*/React.createElement("div", {
    className: "forbidden-container"
  }, /*#__PURE__*/React.createElement("p", {
    className: "alert alert-warning"
  }, localizedStrings.lorule.forbidden));
};

export default Forbidden;